export const RESET_USERS = 'ROGBOT/RESET_USERS';
export const FETCH_USERS_REQUEST = 'ROGBOT/FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'ROGBOT/FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'ROGBOT/FETCH_USERS_FAILURE';
export const UPDATE_STATUS_FILTER = 'ROGBOT/UPDATE_STATUS_FILTER';
export const UPDATE_ROLE_FILTER = 'ROGBOT/UPDATE_ROLE_FILTER';
